import { createAction } from '@reduxjs/toolkit';
import { CategoryGroupsProps } from 'companion-app-components/flux/category-groups/categoryGroupsTypes';
import { getPayloadCreator } from 'companion-app-components/flux/core/actionHelpers';
import { QcsSyncResourcesPayload } from 'companion-app-components/flux/core/resourceStoreTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const categoryGroupsPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<CategoryGroupsProps>>();

export const createCategoryGroupsAction = createAction('CREATE_CATEGORY_GROUPS', categoryGroupsPayloadCreator);
export const createCategoryGroupsSuccessAction = createAction(
  'CREATE_CATEGORY_GROUPS_SUCCESS',
  categoryGroupsPayloadCreator,
);
export const createCategoryGroupsFailureAction = createAction('CREATE_CATEGORY_GROUPS_FAILURE', errorPayloadCreator);
